import React from 'react';

export const CompanyContext = React.createContext({
  name: null,
  setName: () => {},
});